/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Directive, Input, ElementRef,AfterViewInit } from '@angular/core';
import { PLATFORM_ID, Inject } from '@angular/core';
@Directive({
  selector: '[appSuperPlaceholder]'
})
export class SuperPlaceholderDirective implements AfterViewInit {
  @Input() appSuperPlaceholder!: string[];

  constructor(private el: ElementRef,@Inject(PLATFORM_ID) private platformId: any) { }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
    const sp = new SuperPlaceholder({
        placeholders: this.appSuperPlaceholder,
        preText: "Search products by",
        stay: 1000,
        speed: 100,
        element: this.el.nativeElement
    });
    sp.init();
  }
  }
}

// Define an interface for options to improve type safety
interface SuperPlaceholderOptions {
  placeholders: string[];
  preText: string;
  stay: number;
  speed: number;
  element: HTMLElement;
}

class SuperPlaceholder {
  private options: SuperPlaceholderOptions;
  private element: HTMLElement;
  private placeholderIdx: number;
  private charIdx: number;
  private intervalId: any;

  constructor(options: SuperPlaceholderOptions) {
    this.options = options;
    this.element = options.element;
    this.placeholderIdx = 0;
    this.charIdx = 0;
  }

  private setPlaceholder() {
    const placeholder = this.options.placeholders[this.placeholderIdx];
    const placeholderChunk = placeholder.substring(0, this.charIdx + 1);
    this.element.setAttribute('placeholder', this.options.preText + ' ' + placeholderChunk);
  }

  private onTickReverse(afterReverse: () => void) {
    if (this.charIdx === 0) {
      afterReverse();
      clearInterval(this.intervalId);
      this.init();
    } else {
      this.setPlaceholder();
      this.charIdx--;
    }
  }

  private goReverse() {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.onTickReverse(() => {
        this.charIdx = 0;
        this.placeholderIdx++;
        if (this.placeholderIdx === this.options.placeholders.length) {
          this.placeholderIdx = 0;
        }
      });
    }, this.options.speed);
  }

  private onTick() {
    const placeholder = this.options.placeholders[this.placeholderIdx];
    if (this.charIdx === placeholder.length) {
      setTimeout(() => this.goReverse(), this.options.stay);
    } else {
      this.setPlaceholder();
      this.charIdx++;
    }
  }

  init() {
    this.intervalId = setInterval(() => this.onTick(), this.options.speed);
  }

  kill() {
    clearInterval(this.intervalId);
  }
}
